"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ValidationDataModels;
(function (ValidationDataModels) {
  ValidationDataModels["FileSizeValidator"] = "{8F2B6077-FE63-4FB2-8740-EF3807BBDB84}";
  ValidationDataModels["FileTypeValidator"] = "{D81E056F-6C2E-4414-BD46-BA464AC05202}";
  ValidationDataModels["FileCountValidator"] = "{F42833A6-F364-4721-ABFC-337E0CC3FD75}";
})(ValidationDataModels = exports.ValidationDataModels || (exports.ValidationDataModels = {}));